import { render } from "./EmailAlreadyVerified.vue?vue&type=template&id=12bef05a&scoped=true"
import script from "./EmailAlreadyVerified.vue?vue&type=script&lang=js"
export * from "./EmailAlreadyVerified.vue?vue&type=script&lang=js"

import "./EmailAlreadyVerified.vue?vue&type=style&index=0&id=12bef05a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bef05a"]])

export default __exports__